import { atom } from 'recoil';
import { localStorageHandlers } from './localstorage';

export const userState = atom({
  key: 'user',
  default: localStorageHandlers.user.getValue(),
});
